import { createSelector, createFeatureSelector } from '@ngrx/store';
import { NotificationsModuleState, notificationsModuleKey } from './notifications.reducer';
import * as fromNotifications from './notifications.reducer';

const selectNotificationsModuleState = createFeatureSelector<NotificationsModuleState>(notificationsModuleKey);

const selectNotificationsState = createSelector(selectNotificationsModuleState, (state: NotificationsModuleState) => state?.notifications);

export const selectHoverNotifications = createSelector(selectNotificationsState, fromNotifications.getHoverNotifications);
export const selectUnreadNotifications = createSelector(selectNotificationsState, fromNotifications.getUnreadNotifications);
export const selectUnreadQueryParams = createSelector(selectNotificationsState, fromNotifications.getUnreadQueryParams);
export const selectShowNotifications = createSelector(selectNotificationsState, fromNotifications.getShowNotifications);
export const selectNotificationsLoading = createSelector(selectNotificationsState, fromNotifications.getNotificationsLoading);
